import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import {
  quotationSideMsgDetailBlock,
  quotationSideMsgStatusBlock,
} from '#/modules/crmMgmt/quotation/data/quotationSideMsgConfig';

const BLOCKS = [quotationSideMsgStatusBlock, quotationSideMsgDetailBlock];

const QuotationSideMsg = ({ displayData }) => (
  <SideMsg
    title="報價單"
    titleValue="quotationNo"
    displayData={displayData}
    blocks={BLOCKS}
  />
);

QuotationSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default QuotationSideMsg;
